import React from 'react';
import Alert from './Alert';

const ReadOnlyAlert = () => {
  return (
    <Alert severity="info">
      This page is read-only. Please contact your firm administrator to make
      changes to this area.
    </Alert>
  );
};

export default ReadOnlyAlert;
